import RegistrationNumber from './RegistrationNumber';

export default RegistrationNumber;
